import { Injectable} from "@angular/core";
import { CanActivate } from "@angular/router/src/interfaces";
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from "@angular/router";
import { Observable } from "rxjs/Observable";
import { AuthService } from "./auth.service";
import { AppCommonService } from "./appcommon.service";
import { IAccount } from "./headerandnavigation/accounts/account";

@Injectable()
export class AccountGuard implements CanActivate{    
    constructor(private authService: AuthService,private router: Router, private appCommonService: AppCommonService)
    {

    }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
        return this.checkAccountAccess(state.url);
    }
    
    checkAccountAccess(url: string): boolean | Observable<boolean> | Promise<boolean>{        
        if (!this.authService.checkAccessAccountsAuth()) {            
            this.appCommonService.reDirectURL = url;
            return new Observable<boolean>((observer) => {
                setTimeout(() => {
                    this.appCommonService.accountsMenuManualClick();
                    observer.next(false);
                    observer.complete();
                }, 100);
            });
        }
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/app/account-guard.service.ts